const counties = [
	{
		value: 0,
		label: 'Alege'
	},
	{
		value: 'AB',
		label: 'Alba'
	},
	{
		value: 'AR',
		label: 'Arad'
	},
	{
		value: 'AG',
		label: 'Argeş'
	},
	{
		value: 'BC',
		label: 'Bacău'
	},
	{
		value: 'BH',
		label: 'Bihor'
	},
	{
		value: 'BN',
		label: 'Bistriţa-Năsăud'
	},
	{
		value: 'BT',
		label: 'Botoşani'
	},
	{
		value: 'BR',
		label: 'Brăila'
	},
	{
		value: 'BV',
		label: 'Braşov'
	},
	{
		value: 'B',
		label: 'Bucureşti'
	},
	{
		value: 'BZ',
		label: 'Buzău'
	},
	{
		value: 'CL',
		label: 'Călăraşi'
	},
	{
		value: 'CS',
		label: 'Caraş-Severin'
	},
	{
		value: 'CJ',
		label: 'Cluj'
	},
	{
		value: 'CT',
		label: 'Constanţa'
	},
	{
		value: 'CV',
		label: 'Covasna'
	},
	{
		value: 'DB',
		label: 'Dâmboviţa'
	},
	{
		value: 'DJ',
		label: 'Dolj'
	},
	{
		value: 'GL',
		label: 'Galaţi'
	},
	{
		value: 'GR',
		label: 'Giurgiu'
	},
	{
		value: 'GJ',
		label: 'Gorj'
	},
	{
		value: 'HR',
		label: 'Harghita'
	},
	{
		value: 'HD',
		label: 'Hunedoara'
	},
	{
		value: 'IL',
		label: 'Ialomiţa'
	},
	{
		value: 'IS',
		label: 'Iaşi'
	},
	{
		value: 'IF',
		label: 'Ilfov'
	},
	{
		value: 'MM',
		label: 'Maramureş'
	},
	{
		value: 'MH',
		label: 'Mehedinţi'
	},
	{
		value: 'MS',
		label: 'Mureş'
	},
	{
		value: 'NT',
		label: 'Neamţ'
	},
	{
		value: 'OT',
		label: 'Olt'
	},
	{
		value: 'PH',
		label: 'Prahova'
	},
	{
		value: 'SJ',
		label: 'Sălaj'
	},
	{
		value: 'SM',
		label: 'Satu Mare'
	},
	{
		value: 'SB',
		label: 'Sibiu'
	},
	{
		value: 'SV',
		label: 'Suceava'
	},
	{
		value: 'TR',
		label: 'Teleorman'
	},
	{
		value: 'TM',
		label: 'Timiş'
	},
	{
		value: 'TL',
		label: 'Tulcea'
	},
	{
		value: 'VL',
		label: 'Vâlcea'
	},
	{
		value: 'VS',
		label: 'Vaslui'
	},
	{
		value: 'VN',
		label: 'Vrancea'
	}
];

export function getCountyNameByCode(code) {
	let label;
	counties.forEach((county) => {
		if (county.value === code) {
			label = county.label;
		}
	});

	return label;
}

export default counties;
